import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.ProfilesList;

export const statusSelector = createSelector(rootSelector, (groups) => groups.status);

export const errorSelector = createSelector(rootSelector, (groups) => groups.error);

export const groupsSelector = createSelector(rootSelector, (groups) => groups.data);

export default {
  statusSelector,
  errorSelector,
  groupsSelector,
};
